import type { NodeData, NodeId, NodeSn, SnapshotId } from '@ipfabric/utils';
import type { NodeDetailArgs } from 'components/DeviceView/deviceViewTypes';
import { getShowNodeDetailArgs } from 'components/DeviceView/helpers/getShowNodeDetailArgs';
import type { NodeStableDataRecord } from 'components/Graph/model/selectors/selectNodesStableData';
import { record } from 'fp-ts';
import type { GraphMetadata } from '../GraphState';
import { hasNodePathInspectorDetail } from '../commands/pathLookup/hasNodePathInspectorDetail';
import { getParentNodeData, hasNodeDetail } from '../commands/showNodeDetail';
import type { EdgeStableDataRecord } from '../model/selectors/selectEdgesStableData';

export const getUpdatedNodesInGraph = (
  nodes: NodeStableDataRecord,
  edges: EdgeStableDataRecord,
  graphMetadata: GraphMetadata | null,
  nodeSns: NodeSn[],
  snapshotToCompareId: SnapshotId | null,
): Map<NodeSn, NodeDetailArgs> => {
  const nodeIds: NodeId[] = record.keys(nodes);
  return nodeSns.reduce(
    (
      acc: Map<NodeSn, NodeDetailArgs>,
      nodeSn: NodeSn,
    ): Map<NodeSn, NodeDetailArgs> => {
      const foundNodeId = nodeIds.find(
        (nodeId) => nodes[nodeId]?.sn === nodeSn,
      );
      if (foundNodeId !== undefined) {
        // Fixed noUncheckedIndexedAccess NIM-19408
        const nodeData = nodes[foundNodeId]!;
        if (!hasNodeDetail(nodeData.type)) {
          return acc;
        }
        return acc.set(
          nodeSn,
          getShowNodeDetailArgs(
            foundNodeId,
            nodeData as NodeData,
            getParentNodeData(nodes, edges, nodeData),
            hasNodePathInspectorDetail(nodeData as NodeData, graphMetadata),
            nodeData.type,
            snapshotToCompareId,
          ),
        );
      }
      return acc;
    },
    new Map(),
  );
};
